import { render, staticRenderFns } from "./BambooPayment.vue?vue&type=template&id=ffacef0e&scoped=true&"
import script from "./BambooPayment.vue?vue&type=script&lang=js&"
export * from "./BambooPayment.vue?vue&type=script&lang=js&"
import style0 from "./BambooPayment.vue?vue&type=style&index=0&id=ffacef0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffacef0e",
  null
  
)

export default component.exports